var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapaDinamicoBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2ZM428.57,428.54A243.14,243.14,0,1,1,480.87,351,243.34,243.34,0,0,1,428.57,428.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.71 121.28 184.71 121.28 184.71 111.28 67.71 111.28 67.71 407.32 276.63 407.32 276.63 397.32 77.71 397.32 77.71 121.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "286.31 121.28 429.87 121.28 429.87 397.32 334.83 397.32 334.83 407.32 439.87 407.32 439.87 111.28 286.31 111.28 286.31 121.28"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.11,
    cy: 258.04,
    r: 8.7,
    transform: "translate(-39.62 469.5) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.11,237.83A20.21,20.21,0,1,0,276.31,258,20.21,20.21,0,0,0,256.11,237.83Zm0,35.41a15.21,15.21,0,1,1,15.2-15.2A15.22,15.22,0,0,1,256.11,273.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.36,298.45h101V217.63h-101Zm5-75.82h91v70.82h-91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.44,346.14l-5.23-6.6,8.22-12.25.24-13.64,12.3-1.4,22.37-.08,12,17.49,12.85-9.89-6.74-25.42L371,282.76l6.6-13.4-14.32-32.55,13.32-20.4L367.09,200l-16.17,3.2-19.55,2.11L318,193.81l-5.75-4.56-24.68.87-11.61.51-5.62-8.53,4.64-10.65-11.89-21.72-7.13-7.61,5-19.11,7.95-10,10.4-8.76,12.21-8.37,3.2-13.48-9.82-6.93H273L262.2,88l-13.61,9.28-8.75,3.19-19.35-2.63L197.8,114l-.56,1.09c-2.17,4.24-4.82,9.26-5.87,11l-1,.67-1.69,9.67-1.59,4.54-4.51,1.71-7.44,9.79L163,155.33l1.24,6.29-9.47-9.41-8.54,9.8,2.32,15.72-6,11.72,10.61,27.2-3.58,3.67,3.08,36.27,6.28,11.22-2.43,5.77-19.68,15.23-12.42,9.84,2.13,19.27,22.24,15,14.12,1.72,32,4.14c11.93,8.53,24.74,17.88,27.61,20.27,1.45,2.67,4.88,7.49,12.46,17.88l.62.84,20.52,12L288,386.23l12.69,11.4-3.24,6.67-13.2,25.83,24.51,2.95,13.49,12.82,7.61-51.12,5.46-26.49ZM320,392.89l-4.85,32.51-1.94-1.85-13.57-1.64,6.7-13.1,6.6-13.59L291.32,375.8l-33.08,3.65-15.86-9.29c-4.58-6.28-9.46-13.18-10.89-15.46-.56-1.88-2.62-3.43-6.48-6.35-2.49-1.88-6-4.45-10.35-7.63-7.42-5.4-15-10.79-15-10.84l-1-.73-34.49-4.46-11.76-1.43L136,312.21l-1-9.16,8-6.37,21.72-16.8L170,267.19l-7.61-13.6L159.91,224l4.89-5-11.33-29,5.38-10.57-1.55-10.55,8.91,8.84L178,180l-3.39-17.12,6.3-1.49L188.79,151l6.18-2.33,3.41-9.71,1.27-7.27c1-1.66,2.75-4.77,5.93-11l17.48-12.41L241,110.72l12.23-4.47,15.75-10.72,8.66-10.1h4.06l1.7,1.2-.75,3.14-9.23,6.34L261.62,106l-9.89,12.48-6.88,26.49,10,10.7L263.82,172,259,183.07l11.73,17.8,17.23-.76,21-.74,2.65,2.1,16.61,14.21,24.06-2.59,9.8-1.92,2.83,4.92-12.92,19.79,14.62,33.24L359,284.44l13.45,14.83,3.66,13.82-7.53-10.94-27.92.1-21.84,2.46-.34,19.46L307.84,340l9,11.33,8,18.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 402,
    y: 136.98,
    width: 12,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 402,
    y: 160.62,
    width: 12,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 402,
    y: 184.26,
    width: 12,
    height: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapaDinamicoBlanco);
export default __webpack_public_path__ + "static/media/mapa_dinamico_blanco.471d72c4abfb19537fc8fbecaa746d51.svg";
export { ForwardRef as ReactComponent };